import { toast } from 'react-toastify';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import * as actions from './Actions';
import * as api from './Api';
import Types from './Types';

function* getActiveAnnouncements({ payload }) {
    try {
        yield put(actions.addAnnouncementsLoading(true));
        const result = yield call(api.getActiveAnnouncements);
        // Handle both direct array response or wrapped in data property
        const data = Array.isArray(result.data) ? result.data : (result.data?.data || result.data || []);
        yield put(actions.getActiveAnnouncementsSuccess({ data }));
    } catch (error) {
        const { response, message } = error;
        // Don't show error toast for announcements - it's not critical
        yield put(actions.getActiveAnnouncementsFail());
    } finally {
        yield put(actions.addAnnouncementsLoading(false));
    }
}

export default function* StudentAnnouncementsSaga() {
    yield takeLatest(Types.GET_ACTIVE_ANNOUNCEMENTS_REQUEST, getActiveAnnouncements);
}

